'use strict';

var $d = require('./dependency'),
  constants = require('./constants');

exports.init = function (_, apiRequest, cacher, moment, lang, basePath, env, logger) {
    $d._ = _;
    $d.apiRequest = apiRequest;
    $d.cacher = cacher;
    $d.moment = moment;
    $d.lang = lang;
    $d.basePath = basePath;
    $d.env = env;
    $d.logger = logger;

    if(constants.BROWSER === $d.env) {
        if(window) {
            window._mxcLogger = $d.logger;
        }
    } else if(constants.SERVER === $d.env) {
        if(global) {
            global._mxcLogger = $d.logger;
        }
    }

    exports.charts = require('./charts');
    exports.core = require('./core');
    exports.$u = require('./utilities');
    exports.$c = require('./config');

    exports.startFlow = startFlow;
    exports.resetLang = resetLang;

    function startFlow(chartConfig, context, successFn, failFn) {

        context.rejectFields = exports.$c.rejectFields;
        context.dataConfig = chartConfig.dataConfig;
        context.fields = chartConfig.modelFieldKeys;
        context.chartId = chartConfig.chartId;
        context.i18n = chartConfig.i18n;
        context.apiPath = $d.basePath + exports.$c.restApi.relativePath.analytics;
        context._env = $d.env;

        exports.core.flow.trigger(chartConfig.tasks, context, successFn, failFn);
    }

    function resetLang(newLang) {
        $d.lang = newLang;
    }
};

exports.constants = require('./constants');

